module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-straight-2I3O25UC.woff2?875b8c8cb6a2ab6f6075851e7c9e80ec";